"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _radio = _interopRequireDefault(require("../radio"));
var _excluded = ["name", "onBlur", "onChange", "required", "value", "legend", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * An optional wrapper for groups of radio inputs. Passes `name`, `required`,
 * `onChange` handler, and current `checked` status based on the `value` prop
 * to any child radio inputs.
 */
var RadioGroup = exports["default"] = /*#__PURE__*/function (_Component) {
  function RadioGroup() {
    _classCallCheck(this, RadioGroup);
    return _callSuper(this, RadioGroup, arguments);
  }
  _inherits(RadioGroup, _Component);
  return _createClass(RadioGroup, [{
    key: "childIsRadio",
    value: function childIsRadio(child) {
      if (!child) {
        return false;
      }
      return (
        // https://github.com/gaearon/react-hot-loader/issues/304
        child.type === /*#__PURE__*/_react["default"].createElement(_radio["default"], null).type || child.type === 'input' && child.props && child.props.type === 'radio'
      );
    }
  }, {
    key: "renderChild",
    value: function renderChild(child) {
      if (!this.childIsRadio(child)) {
        return child;
      }
      var childProps = {
        name: this.props.name,
        onChange: this.props.onChange,
        onBlur: this.props.onBlur,
        required: this.props.required
      };
      if (this.props.value !== undefined) {
        childProps.checked = this.props.value === child.props.value;
      }
      return /*#__PURE__*/(0, _react.cloneElement)(child, childProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        name = _this$props.name,
        onBlur = _this$props.onBlur,
        onChange = _this$props.onChange,
        required = _this$props.required,
        value = _this$props.value,
        legend = _this$props.legend,
        children = _this$props.children,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement("fieldset", null, /*#__PURE__*/_react["default"].createElement("legend", {
        className: "hiddenVisually"
      }, legend), /*#__PURE__*/_react["default"].createElement("div", _extends({
        role: "radiogroup"
      }, otherProps), _react.Children.map(children, this.renderChild, this)));
    }
  }]);
}(_react.Component);
RadioGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Components to be wrapped. `Radio` components and `input` elements with
   * `type="radio"` have `name`, `onChange`, `checked`, and `required` passed to them.
   * Other elements are passed through as-is.
   */
  children: _propTypes["default"].node,
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  required: _propTypes["default"].bool,
  /**
   * The value of the currently selected radio button. A convenient way to handle controlled radio
   * inputs. If the `value` property of the radio input matches the passed in `value`, that input
   * will be checked.
   */
  value: _propTypes["default"].string,
  /**
   * Required description of radio buttons. Helpful for accessibility.
   */
  legend: _propTypes["default"].string.isRequired
} : {};